// src/components/programs/JobOrders/PreviewJobOrderModal.jsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, CircularProgress, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Close, Print } from "@mui/icons-material";
import ReactDOMServer from "react-dom/server";
import useGetJobOrder from "../../../hooks/jobOrders/useGetJobOrder";
import useExportJobOrderPdf from "../../../hooks/jobOrders/useExportJobOrderPdf";
import PrintJobOrder from "./PrintJobOrder";
import { useGetSettings } from "../../../hooks/Settings/useGetSettings";

const PreviewJobOrderModal = ({ open, onClose, jobOrderId, program, onPrintSuccess }) => {
    const { t, i18n } = useTranslation();
    const lng = i18n.language || "en";

    const { jobOrder, isLoading } = useGetJobOrder(jobOrderId, { enabled: open });
    const { exportJobOrderPdfMutate, isPending: isExporting } = useExportJobOrderPdf();
    const { Settings } = useGetSettings();
    const logoUrl = Settings?.data?.logo?.url || '';

    const handlePrint = () => {
        if (!jobOrder) return;

        const htmlContent = ReactDOMServer.renderToString(
            <PrintJobOrder program={program} jobOrder={jobOrder} lng={lng} t={t} logoUrl={logoUrl} />
        );

        exportJobOrderPdfMutate(
            {
                jobOrderId: jobOrder.id,
                html: htmlContent,
                filename: `${jobOrder.job_number || 'job_order'}.pdf`,
            },
            {
                onSuccess: () => {
                    if (onPrintSuccess) onPrintSuccess();
                }
            }
        );
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {lng === 'ar' ? "معاينة الجوب اوردر" : "Preview Job Order"}
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ backgroundColor: "#f5f5f5" }}>
                {isLoading || !jobOrder ? (
                    <Box display="flex" justifyContent="center" p={4}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={{
                        width: '210mm',
                        minHeight: '297mm',
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        boxShadow: 3,
                        transform: 'scale(0.8)',
                        transformOrigin: 'top center',
                        border: '1px solid #ccc',
                    }}>
                        {/* We render the React Component directly here for the UI preview */}
                        <PrintJobOrder program={program} jobOrder={jobOrder} lng={lng} t={t} logoUrl={logoUrl} />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isExporting}>
                    {lng === 'ar' ? "إلغاء" : "Cancel"}
                </Button>
                <Button
                    onClick={handlePrint}
                    variant="contained"
                    color="primary"
                    startIcon={isExporting ? <CircularProgress size={20} /> : <Print />}
                    disabled={isExporting || isLoading || !jobOrder}
                >
                    {lng === 'ar' ? "تصدير PDF" : "Export PDF"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PreviewJobOrderModal;
